import { CanCreate } from 'labstep-web/components/Entity/Can';
import type { ProtocolCollectionActionCreateFromTemplateWithActiveGroupProps } from 'labstep-web/components/ProtocolCollection/Action/CreateFromTemplate/types';
import {
  Action,
  ProtocolCollectionActionMenu,
} from 'labstep-web/components/ProtocolCollection/Action/Menu';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { Icon } from 'labstep-web/core/Icon';
import { Link } from 'labstep-web/core/Link';
import { FloatingSearchSelect } from 'labstep-web/core/Select/FloatingSearch';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router';

const ProtocolCollectionActionCreateFromTemplateWithActiveGroup: React.FC<
  ProtocolCollectionActionCreateFromTemplateWithActiveGroupProps
> = ({ create, history, activeGroup, body = {} }) => {
  const folderId = body?.folder_id;
  if (
    !folderId &&
    activeGroup &&
    !activeGroup.is_unsorted_folder_protocol_collection_enabled &&
    !activeGroup.default_protocol_collection_folder
  ) {
    return null;
  }

  return (
    <div className="button icon">
      <FloatingSearchSelect
        actionComponentProps={{
          type: 'children',
          children: ({ onClick }) => (
            <div
              style={{ padding: '0px 5px' }}
              onClick={onClick}
              data-cy="core/Select/FloatingSearch"
            >
              <Icon
                name="caret down"
                style={{ padding: '0px 5px' }}
              />
            </div>
          ),
        }}
        alignRight
        entityName={ProtocolCollection.entityName}
        placeholder="Search templates..."
        keepMenuOpen
        autoFocus
        isClearable={false}
        params={{
          is_template: true,
          group_id: activeGroup?.id,
          has_last_version: true,
        }}
        setOptions={(options) => {
          options.forEach((option) => {
            option.icon = 'copy';
          });
          return [
            {
              label: 'Create from template',
              children: (
                <Link
                  unstyled
                  to="group_settings_protocol_templates"
                  params={{ id: activeGroup?.id }}
                >
                  <ActionComponent
                    dataCy="components/ProtocolCollection/Action/CreateFromTemplate:cog"
                    type="icon"
                    icon="cog"
                    elementProps={{
                      popup: { content: 'Manage Templates' },
                    }}
                  />
                </Link>
              ),
              options,
            },
            {
              name: 'New Protocol Template',
              value: 'new',
              icon: 'add',
            },
          ];
        }}
        onChange={(option, input) => {
          const payload = body;
          if (option.value === 'new') {
            payload.is_template = true;
            payload.name = input || null;
          } else {
            payload.parent_protocol_id = option.last_version.id;
          }
          create(payload, {
            onSuccess: ({ response }) => {
              history.push(
                navigation.get('protocol_collection_show', {
                  id: response.result,
                }),
              );
            },
          });
        }}
        getOptionActions={(option) => (
          <ProtocolCollectionActionMenu
            protocolCollection={option as ProtocolCollection}
            actions={[Action.view, Action.duplicate, Action.delete]}
            usePortal
          />
        )}
      />
    </div>
  );
};

export const ProtocolCollectionActionCreateFromTemplate =
  withActiveGroup(
    ProtocolCollectionActionCreateFromTemplateWithActiveGroup,
  );

export const ProtocolCollectionActionCreateFromTemplateContainer: React.FC<
  any
> = (props) => (
  <CanCreate entityName="protocol_collection">
    <EntityCreateContainer
      entityName={ProtocolCollection.entityName}
      showLoaderWhileCreating
      isTemplate
    >
      {({ create, status }) => (
        <ProtocolCollectionActionCreateFromTemplate
          create={create}
          status={status}
          {...props}
        />
      )}
    </EntityCreateContainer>
  </CanCreate>
);

export default withRouter(
  ProtocolCollectionActionCreateFromTemplateContainer,
);
